<template>
  <div class="slider-outer-section">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="define-heading">
            <h2 class="hf_light hf_heading02">{{ heading }}</h2>
          </div>
        </div>
      </div>
      <!-- ================ -->
      <div class="autotabs-container" v-if="loops && loops.length > 0">
        <div class="row">
          <div class="col-sm-4">
            <ul class="nav flex-column nav-tabs nav-pills-custom d-none d-lg-flex d-md-flex" role="tablist" aria-orientation="vertical" id="stepsTab">
              <li class="nav-item" v-for="(singleTabDetail, tabIndex) in loops" :key="tabIndex"
                :class="tabIndex == 0 ? 'active' : ''" role="presentation">
                <a class="nav-link" href="javascript:void(0);" :class="tabIndex == 0 ? 'active' : ''" data-bs-toggle="tab" :data-bs-target="'#v-pills-'+tabIndex" type="button" role="tab" :aria-controls="'v-pills-'+tabIndex" aria-selected="true">
                  <span class="icon-circle"><img :src="iconArray[tabIndex]" alt=""></span>
                  <span class="hf_heading05">{{ singleTabDetail.post_title }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-sm-8">
            <div class="tab-content accordion" id="v-pills-tabContent">
              <div class="tab-pane fade accordion-item" v-for="(singleTabContent, tabContentIndex) in loops" :key="tabContentIndex" :class="tabContentIndex == 0 ? 'show active' : ''" :id="'v-pills-'+tabContentIndex" role="tabpanel" :aria-labelledby="'v-pills-'+tabContentIndex">

                <h2 class="accordion-header d-lg-none d-md-none">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse_'+tabContentIndex" aria-expanded="true"><span class="sm-icon-circle"><img :src="iconArray[tabContentIndex]" alt=""></span>{{ singleTabContent.post_title }}</button>
                </h2>
                <div :id="'collapse_'+tabContentIndex" class="d-lg-block d-md-block" :class="tabContentIndex == 0 ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'" data-bs-parent="#v-pills-tabContent">
                  <div class="accordion-body">
                    <div class="tab-content-body">
                      <img class="lazy" :data-src="singleTabContent.image_url" alt="">
                      <p class="hf_bodytext01">{{ singleTabContent.post_content }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ================ -->
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';

export default {
  data() {
    return {
      currentIndex: 1,
      iconArray: ['/img/sm-crosshair.svg', '/img/sm-pencil.svg', '/img/sm-money.svg']
    };
  },
  props: {
    heading: { type: String, default: '' },
    loops:{ type: Array, default:[] }
  },
  created() {
    // console.log(this.heading, this.loops);
  }
};
</script>
